import classNames from 'classnames';
import { FC } from 'react';

import { ToggleMobileFilters } from '@/features/filters';
import { Sort } from '@/features/sort';
import { FilterAttribute, FilterType, Option } from '@/shared/config';
import ProductFilters from '@/widgets/filters/ui/productFilters/ProductFilters';
import ProductFiltersMobile from '@/widgets/filters/ui/productFiltersMobile/ProductFiltersMobile';

import styles from './filtersPanel.module.scss';

interface FiltersPanelProps {
  filters?: FilterType[];
  selectedFilters?: FilterAttribute[];
  sortOptions?: Option[];
  sortValue?: string;
  mobileActive: boolean;
  onSetFilters: (filters?: Record<number, number[]>) => void;
  onRemoveFilter: (attrId: number, valueId: number) => void;
  onSortSelect: (sort: string) => void;
  onToggleMobile: () => void;
  className?: string;
}

const FiltersPanel: FC<FiltersPanelProps> = (props) => {
  const {
    filters = [],
    selectedFilters = [],
    sortOptions = [],
    sortValue,
    mobileActive,
    onSetFilters,
    onRemoveFilter,
    onSortSelect,
    onToggleMobile,
    className,
  } = props;
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.container__left}>
        {!!filters.length && (
          <>
            <ProductFilters
              filters={filters}
              selectedFilters={selectedFilters}
              onAccept={onSetFilters}
            />
            <ToggleMobileFilters
              className={classNames('is-mob')}
              filters={selectedFilters}
              onClick={onToggleMobile}
            />
            <ProductFiltersMobile
              active={mobileActive}
              close={onToggleMobile}
              filters={filters}
              selectedFilters={selectedFilters}
              onAccept={onSetFilters}
              onRemove={onRemoveFilter}
            />
          </>
        )}
      </div>
      <div className={styles.container__right}>
        <Sort options={sortOptions} value={sortValue} onSelect={onSortSelect} />
      </div>
    </div>
  );
};

export default FiltersPanel;
